import { useQuery } from '@tanstack/react-query';
import { ambientApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';
import { PractitionerSettings } from 'src/models';

type GetPractitionerSettingsResponse = PractitionerSettings;

type GetPractitionerSettingsParams = {
  practitioner_id?: number;
};

export const useGetPractitionerSettings = (
  params: GetPractitionerSettingsParams = {},
  options: UseQueryOverrideOptions<GetPractitionerSettingsResponse> = {}
) => {
  const { practitioner_id } = params;

  return useQuery({
    ...options,
    queryKey: practitioner_id
      ? ['practitionerSettings', practitioner_id]
      : ['practitionerSettings'],
    queryFn: () =>
      ambientApi
        .get<GetPractitionerSettingsResponse>('/practitioners/settings', {
          params: practitioner_id ? { practitioner_id } : undefined,
        })
        .then((res) => res.data),
  });
};
